import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  priceConditionFromModel,
  validatePriceCondition,
  type ReturnValueState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const RETURN_VALUE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnValueState>>,
): ConditionType<ReturnValueState, Condition.ReturnValue> => ({
  name: "Individual item price (deprecated)",
  description(state) {
    if (!state.priceOption) {
      return "The price of an individual item the customer is returning";
    }
    return `The price of an individual item is ${state.priceOption.toLowerCase()} ${moneyFormat({ amount: +state.amount, currency: DEFAULT_CURRENCY })}`;
  },
  Details(props: ConditionTypeDetailsProps<ReturnValueState>) {
    return React.createElement(Details, props);
  },
  empty: { amount: (0).toFixed(2), priceOption: null },
  fromModel(model) {
    return priceConditionFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.RETURN_VALUE,
      amount: +state.amount,
      priceOption: state.priceOption,
    };
  },
  valid(state) {
    return validatePriceCondition(state).valid;
  },
});

export { type ReturnValueState } from "@redotech/redo-model/return-flow/condition-validate";
